import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';

export enum UpdateUsernameActionType {
    UPDATE_USERNAME_REQUEST = 'USERS_UPDATE_USERNAME_REQUEST',
    UPDATE_USERNAME_SUCCESS = 'USERS_UPDATE_USERNAME_SUCCESS',
    UPDATE_USERNAME_FAILURE = 'USERS_UPDATE_USERNAME_FAILURE',
}

export type UpdateUsernameAction =
    | { type: UpdateUsernameActionType.UPDATE_USERNAME_SUCCESS; payload: { username: string } }
    | { type: UpdateUsernameActionType.UPDATE_USERNAME_REQUEST; payload: {} }
    | {
          type: UpdateUsernameActionType.UPDATE_USERNAME_FAILURE;
          payload: { errorResolution: ErrorResolution };
      };
